/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiScreeningPersonScreeningContextConfiguration,
    ApiScreeningPersonScreeningContextConfigurationFromJSON,
    ApiScreeningPersonScreeningContextConfigurationToJSON,
} from '../models';

export interface UpdatePersonScreeningContextRequest {
    apiScreeningPersonScreeningContextConfiguration: Array<ApiScreeningPersonScreeningContextConfiguration>;
}

/**
 * 
 */
export class PersonScreeningContextConfigurationApi extends runtime.BaseAPI {

    /**
     * Fetches person screening context configurations
     */
    async findPersonScreeningContextRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningPersonScreeningContextConfiguration>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/person-screening-context`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningPersonScreeningContextConfigurationFromJSON));
    }

    /**
     * Fetches person screening context configurations
     */
    async findPersonScreeningContext(initOverrides?: RequestInit): Promise<Array<ApiScreeningPersonScreeningContextConfiguration>> {
        const response = await this.findPersonScreeningContextRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates person screening context configuration
     */
    async updatePersonScreeningContextRaw(requestParameters: UpdatePersonScreeningContextRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiScreeningPersonScreeningContextConfiguration>>> {
        if (requestParameters.apiScreeningPersonScreeningContextConfiguration === null || requestParameters.apiScreeningPersonScreeningContextConfiguration === undefined) {
            throw new runtime.RequiredError('apiScreeningPersonScreeningContextConfiguration','Required parameter requestParameters.apiScreeningPersonScreeningContextConfiguration was null or undefined when calling updatePersonScreeningContext.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/person-screening-context`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.apiScreeningPersonScreeningContextConfiguration.map(ApiScreeningPersonScreeningContextConfigurationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiScreeningPersonScreeningContextConfigurationFromJSON));
    }

    /**
     * Updates person screening context configuration
     */
    async updatePersonScreeningContext(requestParameters: UpdatePersonScreeningContextRequest, initOverrides?: RequestInit): Promise<Array<ApiScreeningPersonScreeningContextConfiguration>> {
        const response = await this.updatePersonScreeningContextRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
